import '@babel/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from 'react-query';

import { Editor } from '@splashthat/splash-cms-engine';

/* Utils */
import readFlashMessage from 'utils/readFlashMessage';
import { getInstance as getBootstrap } from 'utils/bootstrap';
import { withInlineStylesAnchor } from 'utils/insertInlineStylesAnchor';
import SuiThemeProvider from '@splashthat/sui/lib/components/SuiThemeProvider';
import fontLoader from 'utils/fontLoader';

/* Components */
import TopLevelAppErrorBoundary from 'common/components/TopLevelAppErrorBoundary';
import registerNotificationCompound from 'common/compounds/Notification/interface/registerSelf';
import NotificationManager from 'common/compounds/NotificationManager';

/* Colors and Fonts */
import { setColors } from 'common/entities/color';
import { setFonts } from 'common/entities/font';
import { setLogos } from 'common/entities/logo';
import { transformLogos } from 'common/entities/logo/utils';
import { transformItem as transformColor } from 'common/entities/color/utils';
import { transformFont } from 'common/entities/font/utils';
/* Base Styles */
import 'common/styles/sui.styl';
import './styles.styl';

import { createStoreInstance } from './store';
import VirtualEventApp from './components/VirtualEventApp';
import VirtualEventAttendeeDataProvider from './contexts/VirtualEventAttendeeDataManager';

/**
 * Get the bootstrap data that PHP left for us
 */
const bootstrap = getBootstrap();
const colors = bootstrap.get('colors', []);
const logos = bootstrap.get('logos', []);

const activeFonts = bootstrap.get('activeFonts', []);
const availableFonts = bootstrap.get('availableFonts');

/**
 * Create the Redux store
 */
const store = createStoreInstance({});
// FIXME probably the usage of this in this entry app can be replaced by the new NotificationManager
const Notification = registerNotificationCompound(store);
readFlashMessage(store);

store.dispatch(setColors(colors.map(transformColor)));
store.dispatch(setFonts(activeFonts.map(transformFont)));
store.dispatch(setLogos(transformLogos(logos)));

fontLoader(availableFonts);
const queryClient = new QueryClient();
/**
 * Expose debugging objects
 */
if (__DEVELOPMENT__) {
    window.store = store;
    window.bootstrap = bootstrap;
}

// Decorating the SuiThemeProvider with our custom anchor element.
const ThemeProvider = withInlineStylesAnchor(SuiThemeProvider);

ReactDOM.render(
    <Router>
        <Switch>
            <Provider store={store}>
                <QueryClientProvider client={queryClient}>
                    <ThemeProvider>
                        <TopLevelAppErrorBoundary>
                            <NotificationManager>
                                <Editor>
                                    <Route path={['*/virtual/session/:sessionId', '*/virtual']}>
                                        <VirtualEventAttendeeDataProvider>
                                            <VirtualEventApp />
                                        </VirtualEventAttendeeDataProvider>
                                        <Notification />
                                    </Route>
                                </Editor>
                            </NotificationManager>
                        </TopLevelAppErrorBoundary>
                    </ThemeProvider>
                </QueryClientProvider>
            </Provider>
        </Switch>
    </Router>,
    document.getElementById('root'),
);
